import { insertIf } from "@features/reports";
import { Organization } from "@models/Organization";
import { User } from "@models/User";
import { upCase } from "@utility/utilityFunctions";
import { CsvSchema } from "@utils/csv";

export const userReport = (org: Organization) => {
  const columns: CsvSchema<User> = [
    { id: "id", label: "ID" },
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    { id: "role", label: "Role", f: (role) => upCase(role, "-") },
    {
      id: "territories",
      label: "Territories",
      f: (territories, user) =>
        territories
          .filter(
            (territory) => territory.organizationId === user.organizationId
          )
          .map((territory) => territory.name)
          .join(", "),
    },
    {
      id: "limitedBrands",
      label: "Brand Visibility",
      f: (brands, user) => {
        if (brands.length === 0) {
          return user.distributorId ? "No Brands" : "No Restrictions";
        }
        return brands.map((brand) => brand.name).join(", ");
      },
    },
    ...insertIf<User>(org.usesDistributors, {
      id: "distributorName",
      label: "Distributor",
    }),
  ];
  return columns;
};
